import { Row } from "antd";
import React from "react";
import CenterGroup from "./components/CenterGroup";
import LeftGroup from "./components/LeftGroup";
import RightGroup from "./components/RightGroup";
import styles from "./styleModule";
const Navigation = (params) => {
  return (
    <>
      <div className={`${styles.navigation}`}>
        <Row style={{ height: "var(--header-height)" }}>
          <LeftGroup {...(params?.left ?? {})} goBack={params.goBack} />
          <CenterGroup {...(params?.center ?? {})} />
          <RightGroup {...(params?.right ?? {})} />
        </Row>
      </div>
    </>
  );
};

export default Navigation;
